import { useEffect, useState } from "react";
import { FaPhoneAlt, FaRegClock, FaSearch } from "react-icons/fa";
import { FiEye } from "react-icons/fi";
import { FaRegCalendar } from "react-icons/fa";
import { MdSpeed } from "react-icons/md";
import { BiGasPump } from "react-icons/bi";
import { LuMessageCircle } from "react-icons/lu";
import { FaCarAlt } from "react-icons/fa";
import { FaGear, FaLocationDot } from "react-icons/fa6";
import {
  getFirestore,
  collection,
  doc,
  query,
  where,
  orderBy,
  onSnapshot,
  getDoc,
} from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import app from "../firebase-config";
import { id_firebase } from "../content-site";
import { retiraMascara } from "../utils/retiraMascara";
import Header from "../components/Header";
import Footer from "../components/Footer";
import FiltrosAvancados from "../components/FiltrosAvancados";
import BannerCarousel from "../components/BannersCarousel";
import { formatMoney } from "../utils/formatMoney";
import { Card, CardContent } from "../components/ui/Card";
import { FiShoppingCart as ShoppingCart, FiCreditCard as CreditCard } from "react-icons/fi";
import { FaAward as Award, FaUsers as Users } from "react-icons/fa";
import Loader from "../components/Loader";
import Button from "../components/ui/Button";
import { Link } from "react-router-dom";
import hero from "../assets/hero-showroom.jpg";
import { ArrowRight, ShieldCheck, HandCoins, Sparkles, Car as CarIcon, Star } from "lucide-react";

const firestore = getFirestore(app);

export default function Home() {
  const [loading, setLoading] = useState(true);
  const [veiculos, setVeiculos] = useState([]);
  const [revenda, setRevenda] = useState({});
  const [filtros, setFiltros] = useState({ marca: "", modelo: "", ano: "" });
  const [filtrosAvancados, setFiltrosAvancados] = useState({
    tipo: "",
    cor: "",
    portas: "",
    kmMax: "",
    precoMin: "",
    precoMax: "",
  });
  const [, setErroFiltro] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);

    async function loadData() {
      const startTime = Date.now();

      const revendaRef = doc(
        collection(firestore, "revenda"),
        id_firebase
      );

      const docSnap = await getDoc(revendaRef);

      if (docSnap.exists()) {
        setRevenda(docSnap.data());
      }

      const q = query(
        collection(
          doc(collection(firestore, "revenda"), id_firebase),
          "veiculos"
        ),
        where("veremovido", "==", 0),
        where("vevendido", "==", 0),
        orderBy("updated_at", "desc")
      );

      const unsubscribe = onSnapshot(q, (querySnapshot) => {
        const items = [];

        querySnapshot.forEach((doc) => {
          const document = doc.data();

          document.id = doc.id;

          if (document["veexibir_site"] !== false) {
            items.push(document);
          }
        });

        setVeiculos(items);

        const elapsed = Date.now() - startTime;

        const minimumTime = 5000;

        const remainingTime = minimumTime - elapsed;

        setTimeout(() => {
          setLoading(false);
        }, remainingTime > 0 ? remainingTime : 0);
      });

      return unsubscribe;
    }

    let unsubscribe;

    loadData().then((unsub) => {
      unsubscribe = unsub;
    });

    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, []);

  function getOpcoesFiltro(campo, marcaSelecionada = "") {
    const modelosFiltrados = veiculos.filter((veiculo) => {
      if (campo === "vefipe_name" && marcaSelecionada) {
        return veiculo.vefipe_marca === marcaSelecionada;
      }
      return true;
    });

    const opcoes = modelosFiltrados
      .map((veiculo) => veiculo[campo])
      .filter((valor, index, self) => valor && self.indexOf(valor) === index);

    return opcoes.sort();
  }

  const handleBuscar = () => {
    if (
      !filtros.marca &&
      !filtros.modelo &&
      !filtros.ano &&
      !Object.values(filtrosAvancados).some((value) => value)
    ) {
      setErroFiltro("Selecione pelo menos um filtro.");
      return;
    }

    const params = new URLSearchParams();
    // Mapeia os nomes dos filtros para os nomes dos campos do veículo
    if (filtros.marca) params.append("vefipe_marca", filtros.marca);
    if (filtros.modelo) params.append("vefipe_name", filtros.modelo);
    if (filtros.ano) params.append("vefipe_ano_modelo", filtros.ano);

    Object.entries(filtrosAvancados).forEach(([key, value]) => {
      if (value) {
        params.append(key, value);
      }
    });

    setErroFiltro("");
    navigate(`/estoque?${params.toString()}`);
  };

  function separarNomeVeiculo(nomeCompleto) {
    if (!nomeCompleto) return { mainName: '', subName: '' };

    const palavras = nomeCompleto.split(' ');

    const STOP_WORDS = [
      'CD', 'SR', 'SRV', 'GR', 'XEI', 'LTZ', 'LX',
      '4X4', '4X2',
      '1.0', '1.2', '1.3', '1.4', '1.5', '1.8', '1.6', '2.0', '2.8',
      'TDI', 'TURBO', 'DIESEL', 'FLEX',
      'AUT', 'AUT.', 'MT', 'CVT'
    ];

    const indexSpec = palavras.findIndex(p =>
      STOP_WORDS.includes(p)
    );

    if (indexSpec === -1) {
      return {
        mainName: palavras.slice(0, 2).join(' '),
        subName: palavras.slice(2).join(' ')
      };
    }

    return {
      mainName: palavras.slice(0, indexSpec).join(' '),
      subName: palavras.slice(indexSpec).join(' ')
    };
  }



  if (loading) {
    return <Loader />;
  }

  return (
    <div className="min-h-screen w-full ">
      <Header />
      <section className="relative overflow-hidden mt-20">
        <img src={hero} alt="Showroom G8 Motors" width={1920} height={1080} className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-hero" />
        <div className="relative flex mx-auto min-h-[88vh] max-w-7xl flex-col justify-center px-4 py-24 sm:px-6 mx-12">
          <p className="text-xs font-semibold uppercase tracking-[0.4em] text-gold">G8 Motors • desde 1984</p>
          <h1 className="mt-6 max-w-3xl text-5xl font-bold uppercase leading-[1.05] tracking-tight text-foreground sm:text-6xl md:text-7xl">
            O carro certo. <br />
            <span className="text-gold">Da escolha à direção.</span>
          </h1>
          <p className="mt-6 max-w-xl text-lg text-foreground/80">
            Seminovos selecionados, avaliação honesta e financiamento sob medida. Bem-vindo à concessionária mais respeitada da região.
          </p>
          <div className="mt-10 flex flex-wrap gap-4">
            <Button asChild variant="gold" size="xl"><Link to="/estoque">Ver estoque</Link></Button>
            <Button asChild variant="outlineGold" size="xl"><Link to="/venda">Avaliar meu carro</Link></Button>
          </div>
          <div className="mt-16 grid max-w-2xl grid-cols-3 gap-8 border-t border-gold/20 pt-8">
            <div><p className="text-3xl font-bold text-gold">+42</p><p className="text-xs uppercase tracking-widest text-muted-foreground">anos no mercado</p></div>
            <div><p className="text-3xl font-bold text-gold">+5.000</p><p className="text-xs uppercase tracking-widest text-muted-foreground">clientes satisfeitos</p></div>
            <div><p className="text-3xl font-bold text-gold">100%</p><p className="text-xs uppercase tracking-widest text-muted-foreground">veículos vistoriados</p></div>
          </div>
        </div>
      </section>

      <section className="border-y border-black/50 bg-surface">
        <div className="mx-auto grid max-w-7xl gap-px bg-border/50 sm:grid-cols-2 lg:grid-cols-4">
          {[
            { icon: ShieldCheck, title: "Procedência garantida", text: "Vistoria completa em todos os veículos." },
            { icon: HandCoins, title: "Melhor avaliação", text: "Pagamos o valor justo no seu usado." },
            { icon: Sparkles, title: "Estoque premium", text: "Modelos selecionados criteriosamente." },
            { icon: CarIcon, title: "Financiamento ágil", text: "Aprovação em até 24 horas." },
          ].map((p) => (
            <div key={p.title} className="flex flex-col gap-3 bg-surface p-8">
              <p.icon className="h-8 w-8 text-gold" />
              <h3 className="text-lg font-semibold uppercase">{p.title}</h3>
              <p className="text-sm text-muted-foreground">{p.text}</p>
            </div>
          ))}
        </div>
      </section>

      <BannerCarousel />

      <section className="mx-auto max-w-7xl px-4 py-24 sm:px-6">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-gold">Em destaque</p>
            <h2 className="mt-2 text-3xl font-bold uppercase sm:text-4xl">Veículos selecionados</h2>
          </div>
          <Button asChild variant="outlineGold"><Link to="/estoque">Ver todo estoque</Link></Button>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-12 mt-6 px-4">
          {veiculos
            .slice()
            .sort(() => Math.random() - 0.5)
            .slice(0, 3)
            .map((veiculo) => {

              const { mainName, subName } = separarNomeVeiculo(
                veiculo.vefipe_name
              );

              const cambio = veiculo.vecambio === 'A' ? 'Automático' : veiculo.vecambio === 'M' ? 'Manual' : veiculo.vecambio;

              veiculo.vecambio = cambio;

              return (
                <div key={veiculo.id} className="bg-card rounded-xl shadow-lg overflow-hidden flex flex-col h-[110%]">
                  <img className="object-contain w-full h-48 md:h-64 lg:h-72" src={veiculo.imagens[0]?.fileUrl} alt={veiculo.titulo} />

                  <div className="p-4 flex-1 flex flex-col justify-between">
                    <div>
                      <h3 className="text-lg font-bold uppercase">
                        {veiculo.vefipe_marca} {mainName}
                      </h3>

                      {subName && (
                        <p className="text-sm text-white uppercase">
                          {subName}
                        </p>
                      )}
                    </div>

                    <div className="grid grid-cols-2 text-white space-y-2 text-sm">
                      <span className="flex items-center gap-1">
                        <MdSpeed className="text-gold" /> {veiculo.vequilometragem}km
                      </span>
                      <span className="flex items-center gap-1">
                        <BiGasPump className="text-gold" /> {veiculo.vefipe_combustivel}
                      </span>
                      <span className="flex items-center gap-1">
                        <FaRegCalendar className="text-gold" /> {veiculo.veano_fabricacao} / {veiculo.vefipe_ano_modelo}
                      </span>
                      <span className="flex items-center gap-1">
                        <FaGear className="text-gold" /> {veiculo.vecambio}
                      </span>
                    </div>

                    <hr className="text-white" />
                    <div className="mt-2 flex gap-4 items-center justify-between">
                      <p className="text-xl font-bold text-yellow-600">
                        {veiculo.vevalor
                          ? formatMoney(veiculo.vevalor)
                          : 'Consulte o preço'}
                      </p>


                      <a
                        href={`/veiculo/${veiculo.id}`}
                        className="bg-yellow-600 text-white px-4 py-2 rounded flex gap-2 items-center"
                      >
                        <FiEye /> Ver Detalhes
                      </a>

                    </div>
                  </div>
                </div>
              );
            })}

        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-24 sm:px-6">
        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-gold">Reputação</p>
        <h2 className="mt-2 text-3xl font-bold uppercase sm:text-4xl">O que dizem nossos clientes</h2>
        <div className="mt-10 grid gap-6 md:grid-cols-3">
          {[
            { name: "Rafael M.", text: "Atendimento impecável do início ao fim. Saí de carro novo no mesmo dia." },
            { name: "Camila S.", text: "Avaliaram meu usado por um valor muito melhor do que outras lojas." },
            { name: "Eduardo P.", text: "Financiamento aprovado super rápido, equipe muito séria. Recomendo!" },
          ].map((t) => (
            <div key={t.name} className="rounded-xl border border-border/60 bg-card p-6">
              <div className="flex gap-1 text-gold">
                {Array.from({ length: 5 }).map((_, i) => <Star key={i} className="h-4 w-4 fill-current" />)}
              </div>
              <p className="mt-4 text-sm text-foreground/85">"{t.text}"</p>
              <p className="mt-4 text-xs uppercase tracking-widest text-muted-foreground">— {t.name}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="relative overflow-hidden bg-gradient-dark">
        <div className="absolute inset-0 [background-image:radial-gradient(circle_at_70%_30%,oklch(0.74_0.13_78/0.18),transparent_55%)]" />
        <div className="relative mx-auto flex max-w-7xl flex-col items-start gap-6 px-4 py-20 sm:px-6 md:flex-row md:items-center md:justify-between">
          <div>
            <h2 className="text-3xl font-bold uppercase sm:text-4xl">Pronto para trocar de carro?</h2>
            <p className="mt-3 max-w-xl text-muted-foreground">Fale com um consultor e descubra a melhor condição para você.</p>
          </div>
          <div className="flex gap-3">
            <Button asChild variant="gold" size="xl"><Link to="/contato">Fale conosco</Link></Button>
            <Button asChild variant="outlineGold" size="xl"><Link to="/financiamento">Simular financiamento</Link></Button>
          </div>
        </div>
      </section>

      <Footer />
    </div >
  );
}
